import { FC } from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const PlannedCareIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 99, height = 32, ...rest }) => {
  const { token } = useToken();
  const textColor = token.colorTextBase;

  return (
    <svg width={width} height={height} viewBox="0 0 99 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M17.3676 24.6895L15.7183 27.2325L14.0021 24.7286L5.07239 11.6998H9.97751L15.6283 19.945L26.3087 3.76784C23.524 1.41852 19.9281 0 15.9996 0C7.16314 0 0 7.16351 0 16C0 24.8365 7.16314 32 15.9996 32C24.836 32 31.9995 24.8365 31.9995 16C31.9995 12.6066 30.9405 9.46254 29.1391 6.87382L17.3676 24.6895Z"
        fill="#F04437"
      />
      <path
        d="M9.97849 11.6998H5.07385L14.0036 24.7281L15.7193 27.232L17.3691 24.689L29.1401 6.87383C28.3359 5.71774 27.3837 4.67333 26.3101 3.76736L15.6298 19.9445L9.97849 11.6998Z"
        fill="white"
      />
      <path
        d="M44.9461 7.95127C46.871 7.95127 48.1322 6.9223 48.1322 5.39596V5.36255C48.1322 3.70283 46.8876 2.8398 45.0121 2.8398H42.0752V7.95127H44.9461ZM40.7636 1.6286H45.1115C47.7336 1.6286 49.4598 3.02264 49.4598 5.31311V5.34603C49.4598 7.8519 47.3685 9.14595 44.8962 9.14595H42.0752V13.245H40.7636V1.6286Z"
        fill={textColor}
      />
      <path d="M50.8386 1.13016H52.1172V13.245H50.8386V1.13016Z" fill={textColor} />
      <path
        d="M59.8343 10.0924V9.29573C59.2035 9.11302 58.3739 8.93067 57.3285 8.93067C55.7353 8.93067 54.8222 9.62691 54.8222 10.6562V10.6893C54.8222 11.7681 55.8181 12.3989 56.9799 12.3989C58.5566 12.3989 59.8343 11.4529 59.8343 10.0924ZM53.5281 10.7562V10.7227C53.5281 8.88074 55.0215 7.91822 57.1956 7.91822C58.2909 7.91822 59.0541 8.06765 59.8173 8.28292V8.0176C59.8173 6.49078 58.8878 5.6942 57.2781 5.6942C56.2662 5.6942 55.4696 5.94337 54.6729 6.30807L54.2913 5.26317C55.2378 4.83118 56.1498 4.53293 57.4109 4.53293C58.6226 4.53293 59.5686 4.86507 60.1825 5.47845C60.7803 6.07627 61.0794 6.90637 61.0794 8.00119V13.245H59.8173V11.9673C59.2204 12.7306 58.241 13.4278 56.7307 13.4278C55.1214 13.4278 53.5281 12.5148 53.5281 10.7562Z"
        fill={textColor}
      />
      <path
        d="M62.8733 4.66583H64.151V6.15864C64.7149 5.22965 65.6113 4.483 67.0884 4.483C69.1626 4.483 70.3738 5.87692 70.3738 7.91822V13.245H69.0961V8.23384C69.0961 6.64069 68.2331 5.64428 66.7237 5.64428C65.2463 5.64428 64.151 6.72354 64.151 8.33285V13.245H62.8733V4.66583Z"
        fill={textColor}
      />
      <path
        d="M72.1846 4.66583H73.4628V6.15864C74.0267 5.22965 74.9231 4.483 76.4 4.483C78.4744 4.483 79.6864 5.87692 79.6864 7.91822V13.245H78.4079V8.23384C78.4079 6.64069 77.5449 5.64428 76.0345 5.64428C74.5581 5.64428 73.4628 6.72354 73.4628 8.33285V13.245H72.1846V4.66583Z"
        fill={textColor}
      />
      <path
        d="M87.7862 8.44923C87.6368 6.88889 86.7408 5.5613 85.048 5.5613C83.5712 5.5613 82.4429 6.78999 82.2601 8.44923H87.7862ZM85.2798 12.3325C86.4586 12.3325 87.2887 11.851 87.9854 11.1213L88.782 11.835C87.919 12.7969 86.8731 13.4443 85.2474 13.4443C82.8905 13.4443 80.966 11.6357 80.966 8.96312C80.966 6.47438 82.7081 4.483 85.0816 4.483C87.6208 4.483 89.0807 6.50779 89.0807 9.03053C89.0807 9.14595 89.0807 9.27885 89.0647 9.47809H82.2601C82.4429 11.2876 83.7705 12.3325 85.2798 12.3325Z"
        fill={textColor}
      />
      <path
        d="M97.3471 8.96312V8.93068C97.3471 6.95534 95.8367 5.62776 94.2436 5.62776C92.5838 5.62776 91.2237 6.85645 91.2237 8.93068V8.96312C91.2237 10.9884 92.6172 12.2826 94.2436 12.2826C95.8367 12.2826 97.3471 10.9385 97.3471 8.96312ZM89.9123 8.98061V8.94672C89.9123 6.14225 91.9534 4.48301 94.0118 4.48301C95.6045 4.48301 96.6334 5.34603 97.2972 6.30807V1.13016H98.5753V13.245H97.2972V11.5194C96.6005 12.5478 95.5875 13.4278 94.0118 13.4278C91.9534 13.4278 89.9123 11.8011 89.9123 8.98061Z"
        fill={textColor}
      />
      <path
        d="M40 24.8953V24.8618C40 21.56 42.4898 18.8549 46.0579 18.8549C48.2476 18.8549 49.5591 19.5851 50.6374 20.6469L49.0117 22.5219C48.1152 21.7093 47.2027 21.2118 46.0409 21.2118C44.0831 21.2118 42.6716 22.8375 42.6716 24.8289V24.8618C42.6716 26.8532 44.0496 28.5134 46.0409 28.5134C47.3685 28.5134 48.1821 27.9824 49.0946 27.1524L50.7209 28.7956C49.5261 30.0731 48.1986 30.8698 45.958 30.8698C42.5393 30.8698 40 28.2307 40 24.8953Z"
        fill={textColor}
      />
      <path
        d="M58.9374 25.8083L57.394 22.0409L55.8507 25.8083H58.9374ZM56.2492 18.9713H58.6061L63.5838 30.6706H60.9122L59.8503 28.0654H54.9377L53.8758 30.6706H51.2706L56.2492 18.9713Z"
        fill={textColor}
      />
      <path
        d="M70.0261 24.696C71.2703 24.696 71.984 24.0323 71.984 23.0533V23.0203C71.984 21.9246 71.2208 21.3606 69.9762 21.3606H67.4364V24.696H70.0261ZM64.8813 19.0536H70.192C71.6684 19.0536 72.8141 19.4687 73.5772 20.2324C74.2245 20.8787 74.5732 21.7917 74.5732 22.8874V22.9205C74.5732 24.796 73.5607 25.9736 72.0833 26.522L74.9214 30.6706H71.934L69.4452 26.9531H67.4364V30.6706H64.8813V19.0536Z"
        fill={textColor}
      />
      <path
        d="M76.3846 19.0536H85.1466V21.3272H78.9233V23.6841H84.3998V25.9576H78.9233V28.397H85.2294V30.6706H76.3846V19.0536Z"
        fill={textColor}
      />
      <path d="M86.6262 19.6811H86.1524V19.365H87.4432V19.6811H86.9692V20.923H86.6262V19.6811Z" fill={textColor} />
      <path
        d="M87.5878 19.365H87.9575L88.367 20.0236L88.7764 19.365H89.1457V20.923H88.8056V19.9059L88.367 20.571H88.3581L87.9241 19.9124V20.923H87.5878V19.365Z"
        fill={textColor}
      />
    </svg>
  );
};

export default PlannedCareIcon;
